import { lazy } from '../../../shared/deployment';

export const JMTLogin = lazy(() => import('./JMTLogin'));
export const JMTLoginV2 = lazy(() => import('./JMTLoginV2'));
export const AuthCatcher = lazy(() => import('./AuthCatcher'));
export const TestJwtToken = lazy(() => import('./TestJwtToken'));
